module.exports = __webpack_public_path__ + "media/images/front/hospitals_search/icon/arrow-fbee0661859edee989b74bc730cc7c46.svg";